// Runtime configuration lives on window.__AXARIS_CONFIG__, populated by /config.js
// (public/config.js in dev / SWA builds; rendered from AXARIS_* env vars by the nginx
// container entrypoint). Precedence for every value: runtime > REACT_APP_* > default.
export function runtime(key) {
  const cfg = typeof window !== "undefined" ? window.__AXARIS_CONFIG__ : undefined;
  const value = cfg && typeof cfg === "object" ? cfg[key] : undefined;
  return typeof value === "string" && value !== "" ? value : undefined;
}

export const API_BASE_URL = runtime("apiBaseUrl") ?? process.env.REACT_APP_API_BASE_URL ?? "/api/v2";

// Backend origin (absolute) for OIDC sign-in/out navigations. These are full-page redirects
// that must hit the backend directly (the /auth/login + /signin-oidc round-trip), not the SPA
// dev proxy. Dev default targets the backend's https profile (port 7185); set
// REACT_APP_AUTH_BASE_URL (or AXARIS_AUTH_BASE_URL in the container) per environment
// (e.g. https://api.axaris.ai/api/v2).
export const AUTH_BASE_URL = runtime("authBaseUrl") ?? process.env.REACT_APP_AUTH_BASE_URL ?? "https://localhost:7185/api/v2";

// Login page branding. "entra" (the SaaS default) shows the Microsoft sign-in copy; "oidc"
// shows provider-neutral copy naming LOGIN_PROVIDER_NAME ("Single Sign-On" when empty).
export const LOGIN_PROVIDER = (runtime("loginProvider") ?? process.env.REACT_APP_LOGIN_PROVIDER ?? "entra").toLowerCase();
export const LOGIN_PROVIDER_NAME = runtime("loginProviderName") ?? process.env.REACT_APP_LOGIN_PROVIDER_NAME ?? "";

// Custom header required by the backend CSRF gate on cookie-authenticated writes.
export const CLIENT_HEADER = "X-Axaris-Client";

export const REDIRECT_URI = runtime("redirectUri") ?? process.env.REACT_APP_REDIRECT_URI ?? "https://localhost:3000/login";

// Where Microsoft sends the admin back after the Security Insights admin-consent flow.
// Must be registered as a Web redirect URI on the SecurityInsights app registration.
// Defaults to the current origin so it works across envs; override with REACT_APP_CONSENT_REDIRECT_URI.
export const CONSENT_REDIRECT_URI = runtime("consentRedirectUri")
  ?? process.env.REACT_APP_CONSENT_REDIRECT_URI
  ?? `${typeof window !== "undefined" ? window.location.origin : "https://localhost:3000"}/settings/integrations/consent-complete`;
export const REACT_APP_TENANT_ID = runtime("tenantId") ?? process.env.REACT_APP_TENANT_ID ?? "6f05f283-574c-44bf-9dba-c99b8e97ff53";
export const REACT_APP_CLIENT_ID = runtime("clientId") ?? process.env.REACT_APP_CLIENT_ID ?? "26ab8753-1bec-4dd2-9c98-8b2c86e48bbe";
export const REACT_APP_GOOGLE_MAPS_API_KEY = runtime("googleMapsApiKey") ?? process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? "";
// PostHog is build-time only: public/index.html substitutes %REACT_APP_POSTHOG_API_KEY% at build.
export const REACT_APP_POSTHOG_API_KEY = process.env.REACT_APP_POSTHOG_API_KEY || "";

// Assessment deletion on screen: the "Delete" button on every assessment list (all 7 assessment flows,
// every scope) and the Enterprise "Deleted assessments" history. They show and hide together.
// Hidden for now; set to true to bring both back. The super-admin check (useRBAC canDeleteAssessments)
// still applies.
export const SHOW_DELETE_ASSESSMENT = false;
